import { Button, Dialog, DialogContent, DialogTitle, Drawer, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ArrowBack } from "@material-ui/icons";
import { Workouts } from "app-interfaces";
import React from "react";
import { useTranslation } from "react-i18next";

import { ExerciseList } from "../Exercises";
import WorkoutsExercise from "../Workouts/AddSetsOfExercises/TabComponent";
import AddSetsOfExercises from "../Workouts/StepForm";

const useStyles = makeStyles((theme) => ({
  dialog: {
    "& .MuiDialog-paperScrollPaper": {
      maxHeight: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
        ? "none"
        : "calc(100% - 64px)",
    },
    "& .MuiDialog-paper": {
      position: "absolute",
      margin: 0,
      top: 0,
      bottom: 0,
    },
    "& .MuiDialog-paperFullWidth": {
      width: "100%",
    },
    "& .MuiDialogTitle-root": {
      height: 75,
      backgroundColor: "var(--text-primary)",
      color: "#ffffff",
      fontSize: 20,
      fontWeight: 500,
      padding: "25px 15px",
      "& svg": {
        cursor: "pointer",
        marginRight: 15,
        marginTop: -2,
      },
    },
    "& .MuiDialogContent-root": {
      height: "85vh",
      "& #step-form .tab": {
        maxHeight: "68vh",
        "& #carousel-section": {
          height: "max-content",
          overflowY: "hidden",
          "& .carousel.slide": {
            // height: 350,
            height: "auto",
            paddingBottom: "60px",
          },
          "& .carousel-indicators": {
            bottom: "20px",
          },
          "& img": {
            // margin: '0 20%',
            width: "100%",
            maxHeight: 250,
          },
        },
        "& .meraNewCard": {
          padding: 0,
        },
      },
      "& #workout-exercise": {
        "& .tab": {
          maxHeight: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? "none" : "68vh",
          "& #carousel-section": {
            height: "max-content",
            overflowY: "hidden",
            "& .carousel.slide": {
              // height: 350,
              height: "auto",
              paddingBottom: "60px",
            },
            "& .carousel-indicators": {
              bottom: "20px",
            },
            "& img": {
              // margin: '0 20%',
              width: "100%",
              maxHeight: 250,
            },
          },
          "& .meraNewCard": {
            padding: 0,
          },
        },
        '& button[type="submit"]': {
          height: 37,
          width: 135,
          borderRadius: 4,
          padding: "6px 12px",
          backgroundColor: "#000000",
          fontSize: 16,
          fontWeight: 500,
          textTransform: "none",
          color: "#ffffff",
          "&:hover": { backgroundColor: "#000000" },
          '&[type="submit"]': {
            backgroundColor: "var(--text-primary)",
            width: "100%",
            "&:hover": { backgroundColor: "var(--text-primary)" },
          },
        },
      },
    },
    "& .MuiDialogActions-root": {
      paddingLeft: 20,
      paddingRight: 20,
      width: "100%",
      "& button": {
        height: 50,
        backgroundColor: "var(--text-primary)",
        color: "#ffffff",
        fontSize: theme.spacing(2),
        textTransform: "capitalize",
      },
    },
  },
  drawer: {
    "& .MuiDrawer-paper": {
      width: 512,
      "& .drawer-heading": {
        height: 75,
        backgroundColor: "var(--text-primary)",
        color: "#ffffff",
        fontSize: 20,
        fontWeight: 500,
        padding: "25px 15px",
        "& svg": {
          cursor: "pointer",
          marginRight: 15,
          marginTop: -2,
        },
      },
      "& .drawer-body": {
        // overflow: 'auto',
        height: "90vh",
        padding: "15px 30px",
        "& #step-form .tab": {
          maxHeight: "80vh",
          "& #carousel-section": {
            height: "max-content",
            overflowY: "hidden",
            "& .carousel.slide": {
              // height: 350,
              height: "auto",
              paddingBottom: "60px",
            },
            "& .carousel-indicators": {
              bottom: "20px",
            },
            "& img": {
              // margin: '0 20%',
              width: "100%",
              maxHeight: 250,
            },
          },
          "& .meraNewCard": {
            padding: 0,
          },
        },
        "& #workout-exercise": {
          "& .tab": {
            maxHeight: "75vh",
            "& #carousel-section": {
              height: "max-content",
              overflowY: "hidden",
              "& .carousel.slide": {
                // height: 350,
                height: "auto",
                paddingBottom: "60px",
              },
              "& .carousel-indicators": {
                bottom: "20px",
              },
              "& img": {
                // margin: '0 20%',
                width: "100%",
                maxHeight: 250,
              },
            },
            "& .meraNewCard": {
              padding: 0,
            },
          },
          '& button[type="submit"]': {
            height: 37,
            width: 135,
            borderRadius: 4,
            padding: "6px 12px",
            backgroundColor: "#000000",
            fontSize: 16,
            fontWeight: 500,
            textTransform: "none",
            color: "#ffffff",
            "&:hover": { backgroundColor: "#000000" },
            '&[type="submit"]': {
              backgroundColor: "var(--text-primary)",
              width: "100%",
              "&:hover": { backgroundColor: "var(--text-primary)" },
            },
          },
        },
      },
    },
  },
  drawerSuperSet: {
    "& .MuiDrawer-paper": {
      width: "86vw",
      "& form#step-form .tab, form#workout-exercise .tab": {
        overflowY: "inherit",
      },
    },
  },
}));

export default function SuperSetForm(props: {
  show: boolean;
  option: string;
  supersetList?: Workouts.IExercise[] | null;
  addExercise?: Workouts.IExercise[] | null;
  superset?: Workouts.IExerciseSuperSet | null;
  editExercise?: {
    exercise: Workouts.IExercise;
    exerciseIndex: number;
    supersetIndex: number;
  } | null;
  onHide: () => void;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}) {
  const classes = useStyles();
  const { t } = useTranslation();
  let modalBody: JSX.Element = <></>;
  switch (props.option) {
    case "Add":
      if (!props.supersetList) break;
      modalBody = (
        <AddSetsOfExercises onSubmit={props.onSubmit} supersetList={props.supersetList}>
          <input
            id="data"
            type="text"
            name="exercises"
            value={JSON.stringify(props.supersetList)}
            style={{ display: "none" }}
            readOnly
          />

          <div className="tab">
            <ExerciseList />
          </div>
        </AddSetsOfExercises>
      );
      break;
    case "Add Exercises":
      if (!props.addExercise) break;
      modalBody = (
        <AddSetsOfExercises onSubmit={props.onSubmit} addExercise={props.addExercise}>
          <input
            id="data"
            type="text"
            name="exercises"
            value={JSON.stringify(props.addExercise)}
            style={{ display: "none" }}
            readOnly
          />
          <div className="tab">
            <ExerciseList />
          </div>
        </AddSetsOfExercises>
      );
      break;
    case "Edit Exercise":
      if (!props.editExercise) break;
      const { exerciseIndex, exercise } = props.editExercise;
      modalBody = (
        <form id="workout-exercise" onSubmit={props.onSubmit}>
          <input
            id="data"
            type="text"
            name="exercises"
            value={JSON.stringify([props.editExercise.exercise])}
            style={{ display: "none" }}
            readOnly
          />
          <WorkoutsExercise exercise={exercise} exerciseIndex={exerciseIndex} mystyle />
          <Button
            id="setTop"
            fullWidth
            variant="contained"
            type="submit"
            style={
              /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
                ? { display: "flex", margin: "20px auto" }
                : {
                    display: "flex",
                    marginLeft: "auto",
                    width: "7rem",
                    marginRight: "2rem",
                    marginTop: "1rem",
                    position: "absolute",
                    // bottom:15,
                    // top:"75px",
                    right: "58px",
                  }
            }
          >
            {t("Save")}
          </Button>
        </form>
      );
      break;
    default:
      break;
  }

  return window.innerWidth < 700 || props.option === "Delete" ? (
    <Dialog
      id="superset"
      open={props.show}
      onClose={props.onHide}
      maxWidth="sm"
      fullWidth
      className={classes.dialog}
    >
      <DialogTitle>
        <ArrowBack onClick={props.onHide} />
        {props.option
          ? props.option === "Add"
            ? `${t("Add")} ${t("superset")}`
            : props.option
          : ""}
      </DialogTitle>
      <DialogContent>{modalBody}</DialogContent>
    </Dialog>
  ) : (
    <Drawer
      id="superset"
      open={props.show}
      onClose={props.onHide}
      anchor="right"
      className={`${classes.drawer} ${props.option === "Edit Exercise" && classes.drawerSuperSet}`}
    >
      <Typography variant="h5" className="drawer-heading">
        <ArrowBack onClick={props.onHide} />
        {props.option
          ? props.option === "Add"
            ? `${t("Add")} ${t("superset")}`
            : `${t(`${props.option}`)}`
          : ""}
      </Typography>
      <div className="drawer-body">{modalBody}</div>
    </Drawer>
  );
}

/**
 * The SuperSetForm stores exercises in the <input id="data"> as a stringified JSON.
 * This approach is to be refactored.
 * This function to get the input from the DOM is a temporary measure to make it easier to refactor later.
 */
export const getSuperSetFormDataInputElement = () => {
  return document.getElementById("data") as HTMLInputElement | null;
};
